module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2n1r4n8n-95d5417abe9213d2bf9e1783fc28ebbc.svg";